import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a view for auto-exclusion users in a record table.
 * @extends JetView
 */
export default class recordTableAutoexclusionUsersView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        return {
            view: 'datatable', // Specifies the view type
            select: true, // Enables row selection
            columns: [
                // Defines the columns of the datatable
                {
                    id: 'package', // Unique identifier for the column
                    header: _('dav'), // Header text, localized
                    fillspace: 2, // Column width behavior
                    minWidth: 100, // Minimum width of the column
                    sort: 'text', // Sorting type
                    format: dateFormat, // Formatting function for the column data
                },
                {
                    id: 'maintainer', // Unique identifier for the column
                    header: 'ID Usuario', // Header text
                    width: 100, // Fixed width of the column
                    sort: 'int', // Sorting type
                },
                {
                    id: 'architecture', // Unique identifier for the column
                    header: 'Transacción ID', // Header text
                    width: 100, // Fixed width of the column
                    sort: 'int', // Sorting type
                },
            ],
            loadahead: 0, // Number of rows to load ahead
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager configuration
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID changes
            grid.load(
                // Loads data into the grid
                devConfig.geturlApi() + // API URL
                    'null/Report/getRegisteredAutoexclusion' + // Endpoint for fetching data
                    '?id=' + // Query parameter for user ID
                    idUser, // User ID to fetch data for
            );
        });
    }
}

// FILE DOCUMENTED
